import { z } from 'zod';
import { Block, BlockSchema } from './Block.types';

import { BlockType, ValuePropBlockConfigSchema } from './blockConfig/Types';

export const ValuePropBlockSchema = BlockSchema.extend({
  blockConfig: ValuePropBlockConfigSchema,
});

export type ValuePropBlock = z.infer<typeof ValuePropBlockSchema>;

export function isValuePropBlock(block: Block): block is ValuePropBlock {
  return block.blockConfig.type === BlockType.ValueProp;
}
